import request from "@helpers/request";
import qs from "qs";
import {
  eraseCookieFromAllPaths,
  removeProfile,
  removeToken,
} from "@helpers/utils";

function logout() {
  removeToken();
  removeProfile();
  eraseCookieFromAllPaths();
  window.location.href = `http://ats.segal-studios.com/Account/Login?ReturnUrl=${
    window.origin
  }/callback/${btoa(window.location.pathname)}`;
}

function login(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .post(`/v1/user/login/`, qs.stringify(params), { ...config });
}

function isLogin(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .get(`/test`, {}, { ...config });
}

const authenticationService = {
  logout,
  login,
  isLogin,
};

export default authenticationService;
